module.exports = __webpack_public_path__ + "static/media/drip.22ab5e25.jpeg";